import type { IPage } from '@/Module/Core/Model/DataModel';
import { OLD_GRADE_ID, StrategyLevelQueryType } from '@/Module/Grade/Model/Enum';
import { getGradeInfoByIdAction } from '@/Module/Grade/Store/Action';
import { findGradeIdBySlugSelector } from '@/Module/Grade/Store/Selector/findGradeIdBySlugSelector';
import { gradeSetSelectedGradeSeoUrl } from '@/Module/Grade/Store/Slice/GradeSlice';
import { LessonListPageContainer } from '@/Module/Lesson/Component';
import { getCourseByCategoryCategoryIdAction } from '@/Module/Lesson/Store/Action';
import { Wrapper } from '@/Module/Store/Component';
const LessonListPage: IPage = () => {
  return <LessonListPageContainer data-sentry-element="LessonListPageContainer" data-sentry-component="LessonListPage" data-sentry-source-file="index.tsx" />;
};
export const getServerSideProps = Wrapper.getServerSideProps(store => {
  return async ({
    query
  }) => {
    const gradeSlug = String(query.gradeSlug);
    if (gradeSlug) {
      const gradeId = findGradeIdBySlugSelector(store.getState(), gradeSlug);
      if (gradeId) {
        await store.dispatch(getGradeInfoByIdAction({
          Includes: StrategyLevelQueryType.GRADE_DATA_BY_ID,
          gradeId
        }));
      }

      // Set the selected grade SEO URL in the store or book links will be corrupted!
      // TODO: change it with a better solution!
      store.dispatch(gradeSetSelectedGradeSeoUrl(gradeSlug));
      const gradeDataId = OLD_GRADE_ID[gradeSlug];
      if (gradeDataId) {
        await store.dispatch(getCourseByCategoryCategoryIdAction({
          id: gradeDataId
        }));
        return {
          props: {}
        };
      }
      return {
        notFound: true
      };
    }
    return {
      notFound: true
    };
  };
});
export default LessonListPage;